module.exports = __webpack_public_path__ + "img/lulu_lemon.eec4921e.jpg";